export default __webpack_public_path__ + "locales/es/JavascriptSdk.json?hash=8f19fdac974d1ea2f79651e424a6fe11";